import classNames from "classnames";
import { lazy, useRef, useState } from "react";
import useTranslate from "hooks/useTranslate";
import useClickInside from "hooks/useClickInside";
import useClickOutside from "hooks/useClickOutside";
// TODO: Удалить

const LazySearchIcon = lazy(() => import("assets/icons/search.svg?react"));

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const InputPhoneCountriesSearch: React.FC<Props> = ({
  value: searchValue,
  onChange,
}) => {
  const t = useTranslate();

  const [isFocus, setIsFocus] = useState(false);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleBlur = () => {
    inputRef.current?.blur();
    setIsFocus(false);
  };

  const handleFocus = () => {
    inputRef.current?.focus();
    setIsFocus(true);
  };

  const handleChangeSearch = (event) => {
    const { value } = event.target;
    onChange(value);
  };

  const handleReset = (e) => {
    e.preventDefault();
    onChange("");
    inputRef.current?.focus();
  };

  useClickInside({
    refs: [inputRef],
    handler: handleFocus,
    isDisable: isFocus,
  });
  useClickOutside({
    refs: [containerRef],
    handler: handleBlur,
    isDisable: !isFocus,
  });

  const clearClass = classNames("InputSearch__clear", {
    dark: import.meta.env.VITE_APP_PROJECT_NAME === "banger",
  });

  return (
    <div className="InputSearch" ref={containerRef}>
      <div className="InputSearch__icon">
        <LazySearchIcon />
      </div>
      <input
        ref={inputRef}
        type="text"
        className="InputSearch__input"
        placeholder={t("casino.countries.search")}
        value={searchValue}
        onChange={handleChangeSearch}
      />
      {isFocus && searchValue.length > 0 && (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <button type="button" className={clearClass} onClick={handleReset} />
      )}
    </div>
  );
};
